<template>
  <router-view />
</template>

<script>
import { mapActions } from 'vuex';
import '@/assets/style.css';

export default {
  methods: {
    ...mapActions('theme', ['applyAppearance', 'initThemeListener']),
  },
  mounted() {
    window.__societyVuetify = this.$vuetify;
    this.applyAppearance({ vuetify: this.$vuetify });
    this.initThemeListener();
  },
}
</script>

<style>
/* Table hover - premium */
.v-data-table tbody tr:hover td {
  background-color: var(--surface2) !important;
  cursor: pointer;
}

/* Premium table styles */
.custom-premium-table { background: var(--surface) !important; }
.custom-premium-table thead th {
  background-color: var(--surface2) !important;
  color: var(--tx4) !important;
  text-transform: uppercase;
  font-size: 10.5px !important;
  letter-spacing: 0.07em;
  font-weight: 700 !important;
  border-bottom: 1px solid var(--border) !important;
  white-space: nowrap;
}
.custom-premium-table tbody td {
  border-bottom: 1px solid var(--border2) !important;
  padding: 14px 16px !important;
  color: var(--tx2) !important;
}

/* Status utilities */
.border-soft   { border: 1px solid var(--border) !important; }
.border-dashed { border: 1px dashed var(--border) !important; }


/* Custom society-admin sidebar sets its own background on .premium-nav-drawer */
.premium-nav-drawer.v-navigation-drawer {
  background: var(--sb, #080d1a) !important;
}
.light-sidebar.premium-nav-drawer.v-navigation-drawer {
  background: #ffffff !important;
}

/* Main content background */
.v-main { background: var(--bg) !important; }
</style>